import { createContext } from "react";

import { ContractState } from "./contract.reducer";
import { AlertColor } from "@mui/material";
import { ESenderRole } from "../../setup/api/services/contract/models";

export interface ContractContext extends ContractState {
  userType: string;
  actorType: ESenderRole;
  pausedState: boolean;
  actions: {
    getContract: () => void;
    resetContractState: () => void;
    showSnackbar: (title: string, color: AlertColor) => void;
    endTransactionSeller: (contractId?: string) => void;
    endTransactionBuyer: (contractId?: string) => void;
  };
}

export const ContractContext = createContext<ContractContext>(
  {} as ContractContext
);

export default ContractContext;
